import React, { useEffect } from "react";
import { Button, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Link, useParams } from "react-router-dom";
import { getSingleHouse } from "../../redux/houseSettingsSlice";

const HouseSettings = () => {
  const dispatch = useDispatch();
  const { Id } = useParams(); // Assuming the house ID comes from the URL
  const { currenthouse, loading, error } = useSelector(
    (state) => state.houseSettings
  );

  useEffect(() => {
    if (Id) {
      dispatch(getSingleHouse(Id));
    }
  }, [dispatch, Id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Error loading data: {error}</p>
      </div>
    );
  }

  if (!currenthouse) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-gray-500">No house details found.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg p-4">
      <div className="bg-gray-200 p-5 rounded-lg">
        <div className="flex justify-between">
          <h1 className="text-xl font-semibold mb-4">
            House No :{currenthouse?.house_number}
          </h1>
          {!currenthouse.user ? (
            <Link to={`/dashboard/addUser/${Id}`} className="my-auto">
              <Button
                type="default"
                className="bg-green-800 text-white hover:bg-green-600 px-4 py-2 rounded-xl"
                icon={<PlusOutlined />}
              >
                Add Resident
              </Button>
            </Link>
          ) : (
            ""
          )}
        </div>
        <div className="bg-white rounded-lg flex px-10 py-8 mt-4">
          <img
            src="https://png.pngtree.com/element_our/sm/20180516/sm_5afc6f6f0d492.jpg"
            className="h-28 w-28 rounded-full"
            alt="profile"
          />
          <div className="ml-24">
            <div className="">
              <p className="text-md font-semibold">user</p>
              <p className="text-sm">{currenthouse?.user?.name}</p>
            </div>
            <div className="mt-4">
              <p className="text-md font-semibold">Email</p>
              <p className="text-sm">{currenthouse?.user?.email}</p>
            </div>
          </div>
          <div className="ml-24">
            <div className="">
              <p className="text-md font-semibold">Emergency Contact</p>
              <p className="text-sm">
                {currenthouse?.user?.emergency_contact ||
                  "no emergency Contact"}
              </p>
            </div>
            <div className="mt-4">
              <p className="text-md font-semibold">Document</p>
              <p className="text-sm">234 Unit</p>
            </div>
          </div>
          <div className="ml-24"></div>
        </div>
        <div className="flex justify-between mt-8 mb-4">
          <h1 className="text-xl font-semibold">Invoice Information</h1>
          <Link
            to={`/dashboard/addinvoice?houseId=${currenthouse?.tenant_id}`}
            className="my-auto"
          >
            <Button
              type="default"
              className="bg-green-800 text-white hover:bg-green-600 px-4 py-2 rounded-xl"
              icon={<PlusOutlined />}
            >
              Add New Invoice
            </Button>
          </Link>
        </div>
        {currenthouse?.invoice?.length > 0 ? (
          <div className="flex flex-col gap-4">
            {currenthouse?.invoice?.map((invoice) => (
              <Link
                to={`/dashboard/singleinvoice/${invoice.id}`}
                className="my-auto"
              >
                <div className="bg-white p-4 rounded-lg px-20 py-8  border-red-400 border-l-[10px]">
                  <div className="flex justify-between">
                    <div>
                      <p className="text-gray-500">Invoice no</p>
                      <p className="font-semibold mt-2">
                        {invoice.invoice_number}
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-500">Due Date</p>
                      <p className="font-semibold mt-2">{invoice.due_date}</p>
                    </div>
                    <div>
                      <p className="text-gray-500">Invoice status</p>
                      <p className="font-semibold mt-2">{invoice.status}</p>
                    </div>
                    <div>
                      <p className="text-gray-500">Remaining amount</p>
                      <p className="font-semibold mt-2">
                        {invoice.remaining_amount}
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-500">Toatal amount</p>
                      <p className="font-semibold mt-2">
                        {invoice.total_amount}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div>Invoice list is empty</div>
        )}
      </div>
    </div>
  );
};

export default HouseSettings;
